import { Pagination } from '$core/models/pagination';
import { Publication } from '$modules/pages/subscriptions/subscription';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable()
export class CrudBaseComponent {
  protected MODEL: any = Publication;
  protected apiRoute = '/';
  protected apiVersion = '/v1';

  public get apiRouteWithVersion(): string {
    return this.apiVersion + this.apiRoute;
  }

  constructor(protected http: HttpClient) {}

  public createItem<T>(item): any {
    return this.http
      .post<T>(`${this.apiRouteWithVersion}`, item)
      .pipe(map((res) => new this.MODEL(res)));
  }

  public getAutocomplete(params) {
    return this.http.get<any[]>(this.apiRouteWithVersion + '/autocomplete', {
      params,
    });
  }

  public updateItem<T>(item): any {
    return this.http
      .put<T>(`${this.apiRouteWithVersion}/${item.id}`, item)
      .pipe(map((res) => new this.MODEL(res)));
  }

  public getItems<T>(params = {}, status?): any {
    return this.http
      .get<Pagination<T>>(this.apiRouteWithVersion, {
        params,
      })
      .pipe(
        map((res) => {
          res.data = res.data.map((el) => new this.MODEL(el, status));
          return res;
        })
      );
  }

  public nextPage<T>(url): any {
    return this.http.request<Pagination<T>>('get', url).pipe(
      map((res) => {
        res.data = res.data.map((el) => new this.MODEL(el));
        return res;
      })
    );
  }

  public getItem<T>(id) {
    return this.http
      .get<T>(`${this.apiRouteWithVersion}/${id}`)
      .pipe(map((res) => new this.MODEL(res)));
  }

  public deleteItem<T>(id): any {
    return this.http.delete<T>(`${this.apiRouteWithVersion}/${id}`);
  }
}
